<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :instanceClass="instanceClassAttr.instanceClass" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.criteria') }}</template>
					<template #content>
						<!-- CRITERES SEARCH -->
						<div class="datatable">
							<div class="card mb-4" style="width:100%">
								<div class="card-header">
									<!-- <div id="panelList" class="card-body  panel-collapse collapse in show"> -->
									<div class="form-row">
										<div class="col-md-6">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.prsPerson')}}
												</label>
												<auto-search :paramsSearch="paramsSearch" @updateOnClick="addPerson" />								
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.dateEntryAfter')}}</label>
												<input type="date" v-model="instance.dateEntryAfter" class="form-control" />
											</div>
										</div>
										<div class="col-md-3">
											<div class="form-group">
												<label>{{ $t('default.dateEntryBefore')}}</label>
												<input type="date" v-model="instance.dateEntryBefore" class="form-control" />
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountInf', { obj: $t(instanceClassAttr.instanceClass+'.payAmount')} ) }}</label>
												<input type="number" step="any" v-model="instance.payAmountInf" class="form-control" @input="amountToLetter($event, 'inf')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.inf != '' " class="amount-letter">
													{{amountLetter.inf}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountEq', { obj: $t(instanceClassAttr.instanceClass+'.payAmount')})}}</label>
												<input type="number" step="any" v-model="instance.payAmountEq" class="form-control" @input="amountToLetter($event, 'eq')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.eq != '' " class="amount-letter">
													{{amountLetter.eq}}
												</span>
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>{{ $t('default.amountSup', { obj: $t(instanceClassAttr.instanceClass+'.payAmount')})}}</label>
												<input type="number" step="any" v-model="instance.payAmountSup" class="form-control" @input="amountToLetter($event, 'sup')" @change="amountLetter = {}"/>
												<span v-if="amountLetter && amountLetter.sup != '' " class="amount-letter">
													{{amountLetter.sup}}
												</span>
											</div>
										</div>
										<div class="col-md-8">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.mvtAccount')}}
												</label>
												<select v-model="instance.mvtAccount" class="form-control" multiple>
													<option v-for="mvtAccount in mvtAccountList" :value="mvtAccount.id" :key="mvtAccount.id">
													{{ mvtAccount.lib}}
													</option>
												</select>										
											</div>
										</div>
										<div class="col-md-4">
											<div class="form-group">
												<label>
													{{ $t(instanceClassAttr.instanceClass+'.username')}}
												</label>
												<select v-model="instance.username" class="form-control">
													<option v-for="user in userList" :value="user" :key="user">
														{{user}}
													</option>
												</select>										
											</div>
										</div>

									</div> <!--end form-row-->
									<div style="text-align:center">
										<b-button class="btn btn-primary btn-sm"
											@click="search()">
											<fa icon="search"/>
												&nbsp; {{ $t('vtabTrans.sSearch') }}
										</b-button>
										&ensp;
										<button class="btn btn-light btn-sm" @click="reset()">
											<fa icon="refresh"/>
											&nbsp; {{ $t('vtabTrans.sReset') }}
										</button>
									</div>

										<!-- </div> -->
								</div>
							</div> <!--end card-body-->
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel :expanded="false">
					<template #title>{{ $t('panel.chart') }}</template>
					<template #content>
						<!-- STATS -->
						<div>
							<chart
								:typeStats="typeStats"
								:chartData="chartData"
								:chartOptions="chartOptions"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<!-- DATA -->
						<div class="datatable">
							<datatable-instance
								:instanceClassAttr="instanceClassAttr"
								ref="componentDatatableInstance"
								@refreshChart="drawChart"
							/>
						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>
		
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import Chart from '@/components/templates/charts/Chart.vue';

	export default {
		name: 'mvtPaymentList',
		components: {
			'header-layout': Header,
			'datatable-instance': DatatableInstance,
			'auto-search': AutoSearch,
			'chart': Chart
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtpayment.label'),
				pageTitle: this.$t('mvtpayment.list'),
				pageIcon: 'list',
				instanceClassAttr: {
					instanceClass: 'mvtpayment',
					routerShow: 'mvtpaymentshow',
					titleIndex: 'nav.mvt',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '5%', 
						actAdd: true, 
						actGet: true, 
						actEdit: false, 
						actDel: false, 
						actPrint: 'produce'
					},
					attrsList: [
						
						{attrName: 'prsPersonLib', attrCol: '30%', searchable: true, sortable: true},
						{attrName: 'mvtAccountLib', attrCol: '15%', searchable: true, sortable: true},
						// {attrName: 'payDateStart', attrCol: '10%', searchable: false, sortable: true},
						// {attrName: 'payDateEnd', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'payAmount', attrCol: '12%', searchable: false, sortable: true},
						{attrName: 'paySolde', attrCol: '12%', searchable: false, sortable: true},
						{attrName: 'payDate', attrCol: '10%', searchable: false, sortable: true},
						{attrName: 'justificatif', attrCol: '20%', searchable: false, sortable: true},
					]
				},
				instance: {
					mvtAccount: [],
					prsPerson: '',
					username:'',
					payAmountInf: '',
					payAmounteq: '',
					payAmountSup: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				},
				paramsSearch: {
					placeholder: 'Search Client',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					defaultValue: this.instance?.person,
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				mvtAccountList: [],
				prsPersonLib: '',
				userList: [],
				amountLetter: {},			
				chartOptions: {
					title: 'Statistique des paiements par ',
					hAxis: {title: 'Employé'},
					vAxis: {title: 'Paie'},
					recap: {title: 'Paies totales', val:0}
				},
				chartData: [],
				typeStats: [
					{id: 'prsPerson', label: this.$t('mvtpayment.prsPerson')},
					{id: 'pay', label: this.$t('mvtpayment.label')},
				],
				typeStat: 'prsPerson',
				
					
			}
		},
		async mounted () {
			if(this.$store.getters.loggedIn) {
				// this.getMvtAccountList();

				let strParams = "typeRender=list"
				strParams = strParams+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"
				if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					strParams = strParams+"&params2=prsStore.id&valParams2="+this.$store.getters.prsInfo.prsStore+"&logParams2=eqL"
				}
				await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParams
				})
				.then(response => {
					if(response.data)
						this.mvtAccountList = response.data;
					if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI']))
						this.instance.mvtAccount.push(this.mvtAccountList[0].id)
				})
				.catch(error => {
					console.log('error catch -mvtAccountList == ', error.message)
				})

				this.getPersonList();
				// GET LIST user
				await this.$store.dispatch('axiosGet', {
					domain: 'user'
				})
				.then(response => {
					// this.userList = response.data
					response.data.forEach(element => {
						this.userList.push(element.username)
					});
				})
				.catch(error => {
					console.log('error catch userList == ', error.message)
				})
				this.search()
			}
			// this.reset()
		},
		methods: {
			async getPersonList(){
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// EMP -> 1
				strParams = strParams+"&aliasList=_prsType,_prsStore"
				strParams = strParams+"&params1=_prsType.id&valParams1="+1+"&logParams1=eqL"
				if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					strParams = strParams+"&params2=_prsStore.id&valParams2="+this.$store.getters.prsInfo.prsStore+"&logParams2=eqL"
				}
				
				strParams = strParams+"&params3=active&valParams3="+true+"&logParams3=eqB"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					// this.prsPersonList = response.data
					this.paramsSearch.filterList = response.data
				})
				.catch(error => {
					console.log('error catch prsPersonList == ', error.message)
				})

			},
			/*async getMvtAccountList(){
				// logCr=or&
				let strParams = "typeRender=list"

				strParams = strParams+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"
				if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					strParams = strParams+"&params2=prsStore.id&valParams2="+this.$store.getters.prsInfo.prsStore+"&logParams2=eqL"
				}

				await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParams
				})
				.then(response => {
					if(response.data)
						this.mvtAccountList = response.data;
					if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI']))
						this.instance.mvtAccount.push(this.mvtAccountList[0].id)
				})
				.catch(error => {
					console.log('error catch -mvtAccountList == ', error.message)
				})
			},*/
			addPerson(row){
				if(row){
					this.instance.prsPerson = row.id
					this.prsPersonLib = row.fullName
				}
				else
					this.instance.prsPerson = ''
			},
			
			reset(){
				this.instance= {
					mvtAccount: [],
					prsPerson: [],
					username:'',
					payAmountInf: '',
					payAmounteq: '',
					payAmountSup: '',
					dateEntryAfter:'',
					dateEntryBefore:''
				}
				if(this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					this.instance.mvtAccount = []
					// this.instance.username = []
				}
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async search() {
				let strParamsForms = "";

				let titreDoc = this.$t(this.instanceClassAttr.instanceClass +'.list')
				
				let	detailsTopC1 = '';
				let	detailsTopC2 = '';

				// Date super
				strParamsForms = strParamsForms+"&params1=payDateStart&valParams1="+this.instance.dateEntryAfter+"&logParams1=geD"
				if(this.instance.dateEntryAfter){
					detailsTopC2 = '<i>'+this.$t('default.dateEntryAfter')+' </i><b> '+ this.$moment(this.instance.dateEntryAfter).format(this.$store.getters.formatDateShort) + '</b>'
				}
				// Date inf
				strParamsForms = strParamsForms+"&params2=payDateStart&valParams2="+this.instance.dateEntryBefore+"&logParams2=leD"
				if(this.instance.dateEntryBefore){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + ' - '
					else
						detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryAfter')+' </i><b> ... </b>'

					detailsTopC2 = detailsTopC2 + '<i>'+this.$t('default.dateEntryBefore')+' </i><b> '+ this.$moment(this.instance.dateEntryBefore).format(this.$store.getters.formatDateShort) + '</b>'
				}

				strParamsForms = strParamsForms+"&params4=mvtAccount.id&valParams4="+this.instance.mvtAccount +"&logParams4=inL"

				strParamsForms = strParamsForms+"&params5=prsPerson.id&valParams5="+this.instance.prsPerson +"&logParams5=inL"
				if(this.instance.prsPerson && this.instance.prsPerson != ''){
					if(detailsTopC1 != '')
						detailsTopC1 = detailsTopC1 + '<br>'
					detailsTopC1 = detailsTopC1 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.prsPerson')+' : </i><b>'+ this.prsPersonLib + '</b>'
				}
			
				// Amout super
				strParamsForms = strParamsForms+"&params6=payAmount&valParams6="+this.instance.payAmountSup+"&logParams6=geDo"
				if(this.instance.payAmountSup){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.payAmount')+' > </i><b> '+this.$store.getters.formatAmount(this.instance.payAmountSup) + '</b>'
				}
				// Amout equal
				strParamsForms = strParamsForms+"&params7=payAmount&valParams7="+this.instance.payAmountEq+"&logParams7=eqDo"
				if(this.instance.payAmountEq){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.payAmount')+' = </i><b> '+this.$store.getters.formatAmount(this.instance.payAmountEq) + '</b>'
				}
				// Amout inf
				strParamsForms = strParamsForms+"&params8=payAmount&valParams8="+this.instance.payAmountInf+"&logParams8=leDo"
				if(this.instance.payAmountInf){
					if(detailsTopC2 != '')
						detailsTopC2 = detailsTopC2 + '<br>'
					detailsTopC2 = detailsTopC2 + '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.payAmount')+'< </i><b> '+this.$store.getters.formatAmount(this.instance.payAmountInf) + '</b>'
				}

				strParamsForms = strParamsForms+"&params9=username&valParams9="+this.instance.username+"&logParams9=eq"
				if(this.$store.getters.prsInfo.prsStore && !this.$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_SUIVI'])){
					// console.log("hhshshs = ", this.$store.getters.prsInfo.prsStore)
					strParamsForms = strParamsForms+"&aliasList=_prsPerson"
					strParamsForms = strParamsForms+"&params10=_prsPerson.prsStore.id&valParams10="+this.$store.getters.prsInfo.prsStore +"&logParams10=eqL"
				}

				strParamsForms = strParamsForms+ "&titreDoc="+ titreDoc
				if(detailsTopC1 != '')
					strParamsForms = strParamsForms+"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParamsForms = strParamsForms+"&detailsTopC2="+detailsTopC2

				this.$refs.componentDatatableInstance.setStrParamsForms(strParamsForms);
				this.$refs.componentDatatableInstance.getDataByCriteria();
			},
			drawChart(val) {
				if(val && !Array.isArray(val))
					this.typeStat = val
				
				// default values
				let statLabel = ["Employé", "Paie par Employé"] 
				let attrKey = 'prsPersonLib'
				let attrValue = 'payAmount'
				if(this.typeStat === 'pay' ){
					statLabel = ["Paie", "Montant par Paie"]
					attrKey = 'justificatif'
					attrValue = 'payAmount'
				}
				
				var dataList = this.$refs.componentDatatableInstance.drawChart(attrKey, attrValue, null)
				this.chartData = [ statLabel ]
				let sumData = 0;
				dataList?.forEach(data => {
					this.chartData.push(data);
					sumData = sumData + data[1]
				});
				this.chartOptions.recap.val = this.$store.getters.formatAmount(sumData)
				if(this.chartOptions.recap.title && this.chartOptions.recap.val){
					let detailsBot = '&detailsBot=<i> '+ this.chartOptions.recap.title +' : <b> '+ this.chartOptions.recap.val +'</b> </i>';
					this.$refs.componentDatatableInstance.addStrParamsForms(detailsBot);
				}
			},
			
			async axiosPost() {
				try {
					await this.$store.dispatch('axiosPost', {
						domain: 'mvtmovement',
						data: this.instanceModal //data
					})
					.then(res => {
						this.instanceModal = res.data;
						// console.log('res.data ', res.data)
						this.modalToggle(this.modalType)
						this.$nextTick(() => {
							let msg = this.$t("mvtmovement.label") + " "+res.data.id;
							this.$store.dispatch('showToast', {
								type: 'success', message: this.$t('toast.created.message', { obj: msg})
							});
						});
					})
					.catch(error => {
						console.log('Error', error.response)
					})
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
		}
		
	}

</script>